import { AppKey } from '@galaxy/marketplace-apps';

export function isRequiredAppSatisfied(requiredAppId: string, availableApps: string[]): boolean {
  return availableApps.includes(requiredAppId);
}

export function isRequiredEditionSatisfied(requiredAppKey: AppKey, availableAppKeys: AppKey[]): boolean {
  const requiredAppId = requiredAppKey.appId;
  const requiredEditionId = requiredAppKey.editionId;
  const exactAvailableEdition = availableAppKeys.find((a) => {
    const appIdMatch = a.appId === requiredAppId;
    const editionsAreFalsy = !a.editionId && !requiredEditionId;
    const editionsMatch = a.editionId === requiredEditionId;
    return appIdMatch && (editionsAreFalsy || editionsMatch);
  });
  const hasExactEdition = !!exactAvailableEdition;
  return hasExactEdition;
}
